import {
  getCountries,
  getStates,
  getAchBankAccounts,
  hasDocumentIdApproved,
  getAchProcessorName,
  processAchDeposit,
} from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    selectedBankAccount: -1,
    selectedEcheck: {
      id: 0,
    },
    bankAccounts: [],
    bankAccountsStatus: {
      loading: false,
      success: false,
      error: false,
    },
    bankName: '',
    bankRoutingCode: '',
    country: '',
    state: '',
    bankAccountNumber: '',
    bankAccountName: '',
    countries: [],
    states: [],
    processorName: '',
    processorNameStatus: {
      loading: false,
      success: false,
      error: false,
    },
    idApproved: false,
    currentState: 'PAYMENT_STEP1', // PAYMENT_STEP1 | PAYMENT_STEP2
    check: null,
    id_photo: null,
    bank_statement: null,
    depositAchStatus: {
      loading: false,
      success: false,
      error: false,
    },
  };
};
const state = getDefaultState();

const getters = {
  getField,
};

const mutations = {
  updateField,
  setCountries(state, countries) {
    state.countries = countries;
  },
  setStates(state, states) {
    state.states = states;
  },
  setBankAccounts(state, arr) {
    state.bankAccounts = arr;
  },
  updateBankAccountsStatus(state, row) {
    state.bankAccountsStatus = {
      ...state.bankAccountsStatus,
      ...row,
    };
  },
  setAchProcessorName(state, name) {
    state.processorName = name;
  },
  updateProcessorNameStatus(state, row) {
    state.processorNameStatus = {
      ...state.processorNameStatus,
      ...row,
    };
  },
  setIdApproved(state, idApproved) {
    state.idApproved = idApproved;
  },
  setCurrentState(state, val) {
    state.currentState = val;
    if (val === 'PAYMENT_STEP1') {
      state.check = null;
      state.id_photo = null;
      state.bank_statement = null;
      state.depositAchStatus = {
        loading: false,
        success: false,
        error: false,
      };
    }
  },
  setCheckFile(state, file) {
    state.check = file;
  },
  setIdPhotoFile(state, file) {
    state.id_photo = file;
  },
  setBankStatementFile(state, file) {
    state.bank_statement = file;
  },
  setDepositAchStatus(state, row) {
    state.depositAchStatus = {
      ...state.depositAchStatus,
      ...row,
    };
  },
  hideSuccessModal(state) {
    Object.assign(state, getDefaultState());
  },
  setSelectedEcheck(state, echeck) {
    state.selectedBankAccount = echeck.id;
    state.selectedEcheck = echeck;
    state.bankName = echeck.bank_name;
    state.bankRoutingCode = echeck.bank_routing_number;
    state.bankAccountNumber = echeck.bank_account_number;
    state.bankName = echeck.bank_name;
    state.bankName = echeck.bank_name;
    state.bankAccountName = echeck.check_holder;
  },
  resetSelectedEcheck(state, rootState) {
    state.selectedEcheck = { id: 0 };
  },
};

const actions = {
  tryGetCountries({ commit, rootState }) {
    getCountries(rootState.settings.brandSettings.book_id, rootState.settings.selectedLocale.short_code).then(r => {
      if (r.data.IsSuccess) {
        commit('setCountries', r.data.Data);
      }
    });
  },
  tryGetStates({ commit, state }) {
    if (state.country)
      getStates(state.country).then(r => {
        if (r.data.IsSuccess) {
          commit('setStates', r.data.Data);
        }
      });
  },
  tryGetAchBankAccounts({ commit }) {
    commit('updateBankAccountsStatus', { loading: true });
    getAchBankAccounts().then(r => {
      if (r.data.IsSuccess) {
        commit('setBankAccounts', r.data.Data);
      }
      commit('updateBankAccountsStatus', { loading: false });
    });
  },
  tryGetHasDocumentIdApproved({ commit }) {
    hasDocumentIdApproved().then(r => {
      if (r.data.IsSuccess) {
        commit('setIdApproved', r.data.Data);
      }
    });
  },
  tryGetAchProcessorNameAndGoStep2({ commit }, { amount }) {
    commit('updateProcessorNameStatus', { loading: true });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    getAchProcessorName(amount).then(r => {
      commit('depositStore/setPostDepositLoading', false, { root: true });
      if (r.data.IsSuccess) {
        commit('setAchProcessorName', r.data.Data);
        commit('setCurrentState', 'PAYMENT_STEP2');
      }
      commit('updateProcessorNameStatus', { loading: false });
    });
  },
  tryDepositAch({ commit, dispatch }, { formData }) {
    commit('setDepositAchStatus', {
      loading: true,
      success: false,
      error: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processAchDeposit(formData).then(r => {
      commit('depositStore/setPostDepositLoading', false, { root: true });
      if (r.data.IsSuccess) {
        dispatch('player/tryGetBalance', null, { root: true });
        commit('setDepositAchStatus', { error: false, success: true });
      } else {
        commit('setDepositAchStatus', { error: true, success: false });
      }
      commit('setDepositAchStatus', { loading: false });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
